/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { END } from 'redux-saga';
import {
    fork, take, put, call,
} from 'redux-saga/effects';
import mbpConfigServerApi from 'mbp-config-server-api';
import mbpBrandClient from 'mbp-api-brand';
import mbpLogger from 'mbp-logger';
import mbpUtil from 'mbp-api-util';

import * as brandActions from './Brand-Actions';
import { operations as configOperations } from '../Config';
import * as ConfigAction from '../Config/Config-Actions';
import { getBrandIdByHostName } from '../../App-Helpers';
import brandsConfig from '../../../../../app/components/AppShell/brandtheme';

const getKey = (entry, brand) => entry.substring(brand.length + 1);
const parseConfig = (rawConfig, domain) => {
    const parsedConfig = {};

    // Pull out brand-specfic properties
    Object.keys(rawConfig).forEach((entry) => {
        if (entry.indexOf(domain) !== -1) {
            const fkey = entry.startsWith(domain) ? getKey(entry, domain) : '';

            if (fkey) {
                parsedConfig[fkey] = rawConfig[entry];
            }
        }
    });

    return parsedConfig;
};

const wcEnv = {};
export function* fetchBrandData({ currentBrandId }) {
    mbpLogger.logDebug({
        currentBrandId,
        function: 'fetchBrandData',
        appName: process.env.npm_package_name,
        module: 'mbp-operations | Brand',
        message: 'Fetch brand data',
    });

    if (currentBrandId) {
        let brand = yield call(mbpBrandClient.getBrandById, wcEnv, currentBrandId);
        if (!brand) {
            brand = brandsConfig?.[currentBrandId];
        }

        mbpLogger.logDebug({
            currentBrandId,
            function: 'fetchBrandData',
            appName: process.env.npm_package_name,
            module: 'mbp-operations | Brand',
            message: 'Fetch brand from API',
        });

        // Uat2 have different repo that listen the mastr brand
        let topic = 'ref-brand';
        const appGraphqlEnv = mbpUtil.getEnv('APP_VERSION_ENV');
        if (appGraphqlEnv === 'uat2') {
            topic = 'ref-brand-beta';
        }

        // Brand Config (ref-brand)
        const brandConfig = yield call(configOperations.onLoadConfig, {
            topic,
            brand,
        });

        mbpLogger.logDebug({
            brandConfig,
            function: 'fetchBrandData',
            appName: process.env.npm_package_name,
            module: 'mbp-operations | Brand',
            message: 'Fetch brand from config server',
        });
        return {
            ...brand,
            ...brandConfig,
        };
    }

    return null;
}

export function* fetchBrand({ hostname }) {
    const brandId = getBrandIdByHostName(hostname);

    // note: this is not an api call
    let brand = yield call(mbpBrandClient.getBrandById, {}, brandId);
    if (!brand) {
        brand = brandsConfig?.[brandId];
    }
    let config = {};

    const host = (typeof window !== 'undefined')
        ? mbpUtil.getEnv('APP_WC_HOST')
        : mbpUtil.getEnv('APP_CONFIG_HOST_SSR');

    const refBrandEnv = mbpUtil.getEnv('APP_REF_BRAND_ENV') || 'ref-brand';
    const topic = 'ref-brand';
    const branch = 'master';

    const cacheKey = host + topic + branch;

    let configResponse = {};
    try {
        configResponse = yield call(
            mbpConfigServerApi.getConfig,
            { host },
            refBrandEnv,
            branch,
        );
    } catch (error) {
        mbpLogger.logError({
            error,
            module: 'Brand-Operations',
            function: 'fetchBrand Saga',
        });
        yield put(brandActions.brandLoadFailed(error));
        return;
    }

    if (configResponse?.data?.propertySources?.length) {
        const [configPropertySource] = configResponse.data.propertySources;
        config = parseConfig(configPropertySource.source, brand.domain);
    }

    const result = {
        ...brand,
        ...config,
    };

    yield put(ConfigAction.configLoaded(brand.domain, topic, config));
    yield put(brandActions.brandLoaded(brandId, result));

    // eslint-disable-next-line consistent-return
    return result;
}

function* onLoadBrand({ user, currentBrandId, hostname }) {
    mbpLogger.logDebug({
        user,
        currentBrandId,
        appName: process.env.npm_package_name,
        module: 'mbp-page',
        message: 'onLoadBrand',
    });

    let brand = null;

    try {
        yield call(fetchBrand, { hostname });
        brand = yield call(fetchBrandData, { currentBrandId });

        if (brand) {
            yield put(brandActions.brandLoaded(currentBrandId, brand));

            return brand;
        }
    } catch (ex) {
        mbpLogger.logError({
            user,
            currentBrandId,
            function: 'onLoadBrand',
            appName: process.env.npm_package_name,
            module: 'mbp-page',
            jsError: ex,
            message: 'onLoadBrand FAILED',
        });
        yield put(brandActions.brandLoadFailed(ex));
    }

    return null;
}

function* watchLoadBrands() {
    let action = yield take(brandActions.loadBrand().type);

    while (action !== END) {
        yield fork(onLoadBrand, action.payload);
        action = yield take(brandActions.loadBrand().type);
    }
}

const watchers = [fork(watchLoadBrands)];

export { onLoadBrand, watchers };
